import { Component, ElementRef, Input, QueryList, ViewChild, ViewChildren, } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { ConfirmationService, Message, ConfirmEventType, MessageService } from 'primeng/api';
import { GlobalConstants } from 'src/app/services/global-constants';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ImageuploadService } from 'src/app/services/imageupload.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { SurveyComponent } from '../../views/survey/survey.component';
import { YouTubePlayer } from '@angular/youtube-player';


@Component({
  selector: 'app-show-detail',
  templateUrl: './show-detail.component.html',
  styleUrls: ['./show-detail.component.scss'],
  providers: [MessageService]
})
export class ShowDetailComponent {
  @ViewChild(SurveyComponent) surveyComponent?: SurveyComponent
  @ViewChildren("player") videoElements?: QueryList<HTMLVideoElement>
  fileName = '';

  updateForm: FormBuilder | any;
  createProgramForm: FormBuilder | any;
  viewDetails: boolean = false;
  completeCourseObject: any
  selected: any
  addUser: boolean = false;
  type!: '';
  sessions: any;
  surveys: any;
  surveysList: any;
  assessments: any;
  courseMaterials: any;

  message: any = undefined
  assessmentsList: any;
  selectedItem!: string;
  editForm = false;
  historyComplete = false;

  messages: Message[] = [];
  courseData: any[] = [];
  fileUploaded: any[] = [];
  updateCourseData: any[] = [];
  createTrainingModal = false

  createSession: boolean = false;
  assessment: boolean = false;
  survey: boolean = false;
  showingSelectUser: boolean = true;

  city: Array<Location | any> = [];
  openProgramModal: boolean = false;
  sectionTypeIdHolder: any

  // file urls 
  apilink = GlobalConstants.apiURL;
  GlobalConstants = GlobalConstants;
  staticURL = GlobalConstants.staticFilesURL;

  trainers = [];
  courseMaterial: boolean = false;

  @Input() courseDetails: any;
  @Input() permissions: any;
  @Input() fromCreateTraining: any;
  @Input() pageCall: any;
  @Input() data: any;
  newAddedSession!: { title: any; type: string; typeId: any; date: any; start_time: any; end_time: any; status: string; active: boolean; };
  courseFormEdit: boolean = false;
  courseUpdateForm: FormBuilder | any;
  timeLineList: any;
  unselect: boolean = false;
  showPDF!: boolean;
  fileProgress!: boolean;
  uploadProgress!: number;
  sessionType: any = 'onsite';
  updateVid!: boolean;
  trainingModal: boolean = false;
  currentDate: Date = new Date;
  sessionAtt: any;
  permission = {
    add_assessment: false,
    add_survey: false,
    online_session: false,
    onside_session: false,
    video_session: false,
    certificate:false
  }
  vidUploaded: boolean = false;
  checkDate: boolean = false;
  updateCurseDate: any;
  sessionLimit: number = 0;
  startTime: any;
  endTime: any;
  startTimeUp: any;
  endTimeUp: any;
  input_vid_url: any;
  id: any;

  player: any;
  ytEvent: any;
  endTimeInvalid: boolean = false;
  endTimeInvalidUpd: boolean = false;
  idUpd: any;
  history_url_id: any;
  vid_url_update: any;
  idView: any;
  history: any = [];
  history_url: string | undefined;
  typeFlag: string = 'Internal';
  selectedGender: any;
  updHistory: boolean = false;
  internalData!: never[];
  exData!: never[];
  internalExter!: string;
  internalExternalValue: string = 'External';
  createSurveyFromCourse = false;
  newSurvey!: boolean;
  number_of_sessions: any;
  reqType: any;
  invalidDate!: string;
  addTrainnerModal!: boolean;
  trainersAdded!: boolean;
  dateExpire!: boolean;
  startSession: boolean = true;
  fileUpload: any;
  updateError!: string;
  externalUser: any;
  selectedTab: any;
  fromTraining!: boolean;
  updateSurveyData: any;
  updateAssesData: any;
  materialOrderChanged: boolean = false;
  trainingTypes: any;
  constructor(private dataService: DataService, private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService,
    private domSenitizer: DomSanitizer,
    private imageUploadService: ImageuploadService
  ) { }

  ngAfterViewInit() {
    // Now you can access all video player native elements
    // console.log('PLAYERS', this.videoElements?.length)
    // this.videoElements?.forEach(player => {
    //   player.ontimeupdate = (e: any) => { 
    //     console.log(e)
    //     this.onTimeUpdate(player) 
    //   };
    // });
  }

  openAttempt() {
    let url;
    if (this.selected?.type == 'SURVEY') {
      url = `/sa/survey/attempt/${this.selected?.surveyId?._id}`
    } else if (this.selected?.type == 'ASSESSMENT') {
      url = `/sa/assessment/attempt/${this.selected?.assessmentId?._id}`
    }
    if (url) {
      window.open(window.location.protocol + '//' + window.location.host + url, "_blank");
    }
  }

  ngOnInit() {
    this.courseDetails

    this.reqType = this.data?.type?.name;

    //user coming from training view restrict all actions add/edit
    if (this.permissions?.view) {
      this.courseDetails.userProfile = true;
    }

    if (this.courseDetails?.fromSkills) {
      const skillTr = this.courseDetails?.dataSkillTraining.find((item: any) => item?.name == "Skill Training");
      this.permission = skillTr?.permissions;
      this.number_of_sessions = skillTr?.number_of_sessions;
      this.reqType = skillTr?.permissions?.type?.name;
    }

    //user coming from training edit
    else if (this.permissions?.type?.name == "Skill Training") {
      this.courseDetails.fromSkills = true;
      this.permission = this.permissions?.type?.permissions;
      this.number_of_sessions = this.permissions?.type?.number_of_sessions;
      this.reqType = this.permissions?.type?.name
    }

    //user coming from create training Id-url
    else if (this.permissions?.name == "Skill Training") {
      this.courseDetails.fromSkills = true;
      this.permission = this.permissions?.permissions;
      this.number_of_sessions = this.permissions?.number_of_sessions;
      this.reqType = this.permissions?.name;

    }


    //user coming from training edit
    else if (this.permissions?.name == "New Branch") {
      this.permission = this.permissions?.permissions;
      this.number_of_sessions = this.permissions?.number_of_sessions;
      this.reqType = this.permissions?.name;
    }

    //user coming from training edit
    else if (this.permissions?.type?.name == "WEEKLY") {
      this.permission = this.permissions?.type?.permissions;
      this.number_of_sessions = this.permissions?.type?.number_of_sessions;
      this.reqType = this.permissions?.type?.name;

    }


    else {
      this.permission.add_assessment = this.permissions?.type?.permissions?.add_assessment;
      this.permission.add_survey = this.permissions?.type?.permissions?.add_survey;
      this.permission.online_session = this.permissions?.type?.permissions?.online_session;
      this.permission.onside_session = this.permissions?.type?.permissions?.onside_session;
      this.permission.video_session = this.permissions?.type?.permissions?.video_session;
      this.permission.certificate = this.permissions?.type?.permissions?.certificate;
    }

    this.courseUpdateForm = new FormGroup({
      title: new FormControl()
    });

    this.updateForm = new FormGroup({
      title: new FormControl()
    });

    this.courseDetail(this.courseDetails, false)


    if (this.courseDetails?.fromCreateCourse && this.permissions?.name != "Skill Training") this.addAttendees(false);

    if (!this.reqType && this.courseDetails?.type) {
      this.reqType = this.courseDetails?.type;
    }
    if (this.reqType == 'Skill Training') {
      this.getCompanyData();
      this.getTrainingTypes();
    }
    else {
      this.getTrainers('Internal');
      this.reqType != 'WEEKLY' && this.reqType != 'Unified session' ? this.getTrainers('External') : '';
    }

  }

  // get training types
  private async getTrainingTypes(): Promise<void> {
    console.log("res.error ===> res.error")
    let res = await this.dataService.postData('training-type/get', {
      active: true,
    });

    if (res.error) { return }

    this.trainingTypes = res.data.filter((item: any) => item.name == this.reqType);
    this.number_of_sessions = this.trainingTypes[0].number_of_sessions;
    this.permission = this.trainingTypes[0].permissions;
  }

  getCompanyData = async () => {
    try {
      this.externalUser = localStorage.getItem('externalUser');

      let res = await this.dataService.getData('company/coordinator/' + JSON.parse(this.externalUser).company);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.exData = res.data[0]?.trainers ? res?.data[0]?.trainers.map((item: any) => {

        return {

          name: `${item?.name?.first}   ${item?.name?.middle} ${this.courseDetails?.fromSkills && item?.externalUser?.company?.name ? `( ${item?.externalUser?.company?.name ? item?.externalUser?.company?.name : ''} )` : ''} `,
          user_id: item._id,
          company_id: item?.externalUser?.company?._id,
          email: item?.email

        };
      }) : '';

    } catch (error) {
      console.log(error);
    }
    this.internalExternal('External');
  };
  
  internalExternal(selectedValue: string) {

    this.internalExternalValue = selectedValue;
    if (selectedValue == 'Internal') this.trainers = this.internalData;
    else this.trainers = this.exData;
    if (this.trainersAdded) {
      this.createProgramForm.controls['trainer']?.setValue(this.trainers[this.trainers.length - 1]);
      this.trainersAdded = false;
    }
  }

  getTrainers = async (flag: string) => {
    try {
      let query: any
      if (flag == 'Internal') {
        query = {
          'externalUser.status': { $ne: true },
          'externalUser.role': 'trainer'
        }
      }
      if (flag == 'External') {
        query = {
          'externalUser.status': true,
          'externalUser.role': 'trainer'
        }
      }
      let res = await this.dataService.postData('user/get', query);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }

      if (flag == 'Internal') {
        this.internalData = res?.data.map((item: any) => {
          return {
            name: `${item?.name?.first}  ${item?.name?.middle} ${item?.name?.last} ${this.courseDetails?.fromSkills && item?.externalUser?.company?.name ? `( ${item?.externalUser?.company?.name ? item?.externalUser?.company?.name : ''} )` : ''} `,
            user_id: item._id,
            company_id: item?.externalUser?.company?._id,
            email: item?.email

          };
        });
      }
      else if (flag == 'External') {
        this.exData = res?.data.map((item: any) => {

          return {

            name: `${item?.name?.first}   ${item?.name?.middle}  ${item?.name?.last} ${this.courseDetails?.fromSkills && item?.externalUser?.company?.name ? `( ${item?.externalUser?.company?.name ? item?.externalUser?.company?.name : ''} )` : ''} `,
            user_id: item._id,
            company_id: item?.externalUser?.company?._id,
            email: item?.email

          };
        });
      }
      this.internalExternal(flag);
    } catch (error) {
      console.log(error);
    }
  };

  onInputChangeVideo() {
    if (this.input_vid_url && this.input_vid_url?.includes('www.youtube.com')) {
      const videoIdMatch = this.input_vid_url.match(/[?&]v=([^&]+)/);
      this.id = videoIdMatch ? videoIdMatch[1] : null;
      this.vidUploaded = false;
      this.createProgramForm.controls['video_url']?.setValue(this.input_vid_url);
    }
  }

  ChangeVideoUpd() {
    if (this.vid_url_update && this.vid_url_update?.includes('www.youtube.com')) {
      const videoIdMatch = this.vid_url_update.match(/[?&]v=([^&]+)/);
      this.idUpd = videoIdMatch ? videoIdMatch[1] : null;
      this.updateVid = false;
      this.updateForm.controls['video_url']?.setValue(this.vid_url_update);
    }
  }

  onStateChange(event: any, player: YouTubePlayer) {
    if (event.data === YT.PlayerState.PLAYING) {
      setInterval(() => {
        const currentTime = player.getCurrentTime();
        const duration = player.getDuration();
        let completionPercentage = Math.floor((currentTime / duration) * 100);
        console.log('YOUTUBE COMPLITION PERCENTAGE', completionPercentage, this.selected.typeId._id);
      }, 1000);
    }
  }

  onTimeUpdate(videoPlayer: HTMLVideoElement) {
    const currentTime = videoPlayer.currentTime;
    const duration = videoPlayer.duration;
    let completionPercentage = Math.floor((currentTime / duration) * 100);
    console.log('VIDEO COMPLITION PERCENTAGE', completionPercentage, this.selected.typeId._id)
  }

  saveVideoProgress() {

  }

  savePlayer(player: any) {
    this.player = player;
  }

  playVideo() {
    this.player.playVideo();
  }

  pauseVideo() {
    this.player.pauseVideo();
  }
  //set data to templates data memb
  courseDetail(course: any, view: boolean) {

    this.sessions = [];
    this.assessmentsList = [];
    this.surveysList = [];
    this.history = [];
    this.updHistory = false;
    this.courseMaterials = course && course?.courseMaterial ? course?.courseMaterial : [];
    if (course && course?.session?.length) {

      this.sessionLimit = course?.session?.length;

      this.timeLineList = course.session.sort((current: any, next: any) => new Date(current.date).getTime() - new Date(next.date).getTime());
      this.timeLineList.forEach((session: any) => {
        if (session?.type?.toUpperCase() == 'SESSION') {
          this.sessions.push(session);

          this.history
          session

          //is my cehk krna h k vids wali push q ho ri h ni honi cahye..!
          if (!session?.sessionId?.video_url && this.permissions?.status === 'PUBLISHED' || this.permissions?.status == 'COMPLETED') {
            this.history.push(session);

          }
          this.history
          session


        }
        session?.type?.toUpperCase() == 'ASSESSMENT' ? this.assessmentsList.push(session) : '';
        session?.type?.toUpperCase() == 'SURVEY' ? this.surveysList.push(session) : '';
      });

      console.log('SESSIONS', this.sessions);

      if (this.selected && this.selected?._id) {
        this.selected = this.timeLineList.find((item: any) => item._id === this.selected?._id);
      }
      else this.selected = course?.session[course?.session.length - 1];

      this.tabChange(course?.session, 'session');
    }

    else if (this.courseMaterials?.length) {
      this.selected = this.courseMaterials[0];
      this.showPDF = true;
      this.selectedItem = this.selected?.title + this.selected?.url;
      this.tabChange(this.courseMaterials, 'courseMaterial');
    }

    this.materialOrderChanged ? this.tabChange(this.courseMaterials, 'courseMaterial') : '';

    this.completeCourseObject = course;
    this.viewDetails = !view;

    this.readyYoutubeView(this.selected);

    this.dateExpire = this.checkDateExpire(this.completeCourseObject.end_date);

    //  coming edit from skills Tr.. TRAINING_CREATED/REVISION means fr expire k bad b actions krsgta h add/Edit
    if (this.permissions?.SkillEdit && this.permissions?.status === 'TRAINING_CREATED' || this.permissions?.status === 'REVISION') {
      this.dateExpire = false
    }
    this.materialOrderChanged = false;
  }

  checkDateExpire(date: any) {

    if (new Date(date).getFullYear() < this.currentDate.getFullYear()) return true;
    else if (new Date(date).getFullYear() == this.currentDate.getFullYear() && new Date(date).getMonth() < new Date(this.currentDate.toUTCString()).getMonth()) return true;
    else if (new Date(date).getFullYear() == this.currentDate.getFullYear() && new Date(date).getMonth() == new Date(this.currentDate.toUTCString()).getMonth() && new Date(date).getDate() < new Date(this.currentDate).getDate()) return true;
    else return false;
  }


  editHistory(history_url: any) {
    this.updHistory = true;
    this.history_url = history_url;
  }
  // highLight selected
  select(selected: any, history?: any) {
    this.history_url_id = '';
    this.selectedItem = this.selectedTab.tabTitle == 'courseMaterial' ? selected?.title + selected?.url : selected?._id;
    this.updateForm.reset();
    this.editForm = false;
    this.history_url = '';
    this.updHistory = false;


    if (selected?.history?.history && selected.history.history.includes('www.youtube.com')) {
      this.historyChange(selected?.history?.history);
    }


    // change new UI design
    this.selected = selected;
    this.historyComplete = false;
    this.readyYoutubeView(selected);

    if (new Date(this.selected?.date).getFullYear() > this.currentDate.getFullYear()) this.startSession = false;
    else if (new Date(this.selected?.date).getFullYear() == this.currentDate.getFullYear() && new Date(this.selected?.date).getMonth() > new Date(this.currentDate.toUTCString()).getMonth()) this.startSession = false;
    else if (new Date(this.selected?.date).getFullYear() == this.currentDate.getFullYear() && new Date(this.selected?.date).getMonth() == new Date(this.currentDate.toUTCString()).getMonth() && new Date(this.selected?.date).getDate() > new Date(this.currentDate).getDate()) {

      this.startSession = false;

    }
  }

  readyYoutubeView(session: any) {
    if (session?.typeId?.video_url && session?.typeId?.video_url?.includes('www.youtube.com')) {

      const videoIdMatch = session?.typeId.video_url.match(/[?&]v=([^&]+)/);
      this.idView = videoIdMatch ? videoIdMatch[1] : null;

    }
  }

  // update Session,Assessment,Survey and course matirials
  async updateForms(type: string, history_url?: any) {
    this.updateVid = false;
    this.updHistory = false;
    try {
      !history_url ? this.editForm = !this.editForm : '';
      if (this.updateForm.valid) {
        if (type == 'SESSION' || type == 'ASSESSMENT' || type == 'SURVEY') {
          history_url ? this.editForms(history_url) : '';
          this.sessionUpdate(history_url)

        }
        else this.updateCourse('');
      }

    } catch (error) {

      console.log(error)
    }
    this.updateCourseData = [];
  }

  historyChange(value: string) {
    this.history_url = '';
    this.history_url_id = '';

    console.log('Input field value changed to:', value);
    if (value && value?.includes('www.youtube.com')) {
      const videoIdMatch = value.match(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
      this.history_url_id = videoIdMatch ? videoIdMatch[1] : null;

    }
  }

  //Edit selected session or course materials
  async editForms(history_url?: string) {
    this.checkDate = false;

    if (!history_url) this.editForm = !this.editForm;

    this.vid_url_update = '';
    this.updateForm = this.formBuilder.group({
      title: ['', [Validators.required, Validators.minLength(3)]],
      date: [Validators.required],
      start_time: [this.selected?.type == 'SURVEY' ? '' : Validators.required],
      end_time: [this.selected?.type == 'SURVEY' ? '' : Validators.required],
      is_online: false,
      trainer: '',
      video_url: '',
      zoom_url: '',
      houseNumber: '',
      city: '',
      street: '',
      name: '',
      url: ''
    });
    if (this.selected?.typeId) {
      const index = this.trainers?.length && this.trainers?.findIndex((obj: any) => obj.user_id === this.selected?.typeId?.trainer?.user_id);
      this.selected.zoom_url = this.selected?.typeId?.zoom_url ? this.selected?.typeId?.zoom_url : '';
      this.selected.video_url = this.selected?.typeId?.video_url ? this.selected?.typeId?.video_url : '';
      this.selected.houseNumber = this.selected?.typeId?.address?.houseNumber ? this.selected?.typeId?.address?.houseNumber : '';
      this.selected.city = this.selected?.typeId?.address?.city ? this.selected?.typeId?.address?.city : '';
      this.selected.street = this.selected?.typeId?.address?.street ? this.selected?.typeId?.address?.street : '';
      this.selected.name = this.selected?.typeId?.name ? this.selected?.typeId?.name : '';
      this.selected.trainer = this.trainers?.length ? this.trainers[index] : this.selected?.typeId?.trainer,
        this.selected.is_online = this.selected?.typeId?.is_online ? this.selected?.typeId?.is_online : false
    }
    this.selected.date = new Date(this.selected.date);

    if (!history_url) {
      if (this.selected?.type && this.selected?.type == 'ASSESSMENT') await this.getAssessments();
      if (this.selected?.type && this.selected?.type == 'SURVEY') await this.getSurveys();
      if (this.selected?.type && this.selected?.type == 'SESSION') await this.getCity();
    }
    this.updateForm.patchValue(this.selected);
    this.updateCourseData = [];
  }

  // right tabs change event
  tabChange(selected?: any, name?: string) {
    
    this.updateCourseData = [];
    this.editForm = false;
    this.selectedTab = selected;
    this.selectedTab.tabTitle = name;
    this.showPDF = false;
    this.historyComplete = false;

    if (name === "session") { this.selected = this.selectedTab[0]; this.selectedItem = this.selected?._id; }

    if (name === "assessment") { this.selected = this.selectedTab[0]; this.selectedItem = this.selected?._id; }



    if (name === "survey") { this.selected = this.selectedTab[0]; this.selectedItem = this.selected?._id; }



    if (name === "courseMaterial") {
      this.selected = this.selectedTab[0]; this.showPDF = true; this.selectedItem = this.courseMaterials[0]?.title + this.courseMaterials[0]?.url;
    }


    if (name === "timeLine") { this.selected = this.selectedTab[0]; this.selectedItem = this.selected?._id; }



    if (name === "history") {
      this.selected = this.selectedTab[0]; this.selectedItem = this.selected?._id;
      this.historyChange(this.selected?.history?.history);
      this.historyComplete = true;
    }

    if (new Date(this.selected?.date).getFullYear() > this.currentDate.getFullYear()) this.startSession = false;
    else if (new Date(this.selected?.date).getFullYear() == this.currentDate.getFullYear() && new Date(this.selected?.date).getMonth() > new Date(this.currentDate.toUTCString()).getMonth()) this.startSession = false;
    else if (new Date(this.selected?.date).getFullYear() == this.currentDate.getFullYear() && new Date(this.selected?.date).getMonth() == new Date(this.currentDate.toUTCString()).getMonth() && new Date(this.selected?.date).getDate() > new Date(this.currentDate).getDate()) {
      this.startSession = false;
    }

  }

  changeSessionActivation() {
    this.startSession = true;
    if (new Date(this.selected?.date).getFullYear() > this.currentDate.getFullYear()) this.startSession = false;
    else if (new Date(this.selected?.date).getFullYear() == this.currentDate.getFullYear() && new Date(this.selected?.date).getMonth() > new Date(this.currentDate.toUTCString()).getMonth()) this.startSession = false;
    else if (new Date(this.selected?.date).getFullYear() == this.currentDate.getFullYear() && new Date(this.selected?.date).getMonth() == new Date(this.currentDate.toUTCString()).getMonth() && new Date(this.selected?.date).getDate() > new Date(this.currentDate).getDate()) {
      this.startSession = false;
    }
  }

  


  onTabChange(item: any) {
    this.showPDF = false;
    this.historyComplete = false;
    if (item?.originalEvent?.currentTarget?.innerText === "الجلسات التدريبية") { this.selected = this.sessions[0]; this.selectedItem = this.selected?._id; }

    if (item?.originalEvent?.currentTarget?.innerText === "الاختبارات") { this.selected = this.assessmentsList[0]; this.selectedItem = this.selected?._id; }



    if (item?.originalEvent?.currentTarget?.innerText === "الاستبيانات") { this.selected = this.surveysList[0]; this.selectedItem = this.selected?._id; }



    if (item?.originalEvent?.currentTarget?.innerText === "المصادر") {
      this.selected = this.courseMaterials[0]; this.showPDF = true; this.selectedItem = this.selected?.title + this.selected?.url;
    }


    if (item?.originalEvent?.currentTarget?.innerText === "المحتويات") { this.selected = this.timeLineList[0]; this.selectedItem = this.selected?._id; }



    if (item?.originalEvent?.currentTarget?.innerText === "حضور") {
      this.selected = this.history[0]; this.selectedItem = this.selected?._id;
      this.historyChange(this.selected?.history?.history);
      this.historyComplete = true;
    }

  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }
  // update program before session update
  async updateProgram(programId: string) {
    let program = {
      "_id": programId,
      "trainer": this.updateForm.value.trainer ? this.updateForm.value.trainer : this.selected.typeId.trainer,
      "is_online": this.updateForm.value.is_online ? this.updateForm.value.is_online : false,
      "video_url": this.updateForm.value.video_url ? this.updateForm.value.video_url : '',
      "zoom_url": this.updateForm.value.zoom_url ? this.updateForm.value.zoom_url : '',
      "address": { houseNumber: this.updateForm.value.houseNumber, city: this.updateForm.value.city, street: this.updateForm.value.street }

    }
    let response: any = await this.dataService.postData('program/', program, 'PUT', false);
    if (response.error == true) this.message = response.msg;
    else this.message = response.msg;
  }


  openURL(url: string) {
    if (url) window.open(url.toString(), '_blank');
  }

  async sessionUpdate(history_url?: string) {
    let sessionUpdated: any;
    this.history_url = history_url;

    this.completeCourseObject?.session?.forEach((item: any) => {
      if (this.selected?._id == item._id) sessionUpdated = item;
    })

    if (this.selected?.type == 'SESSION' || this.selected?.type == 'SURVEY' || this.selected?.type == 'ASSESSMENT') {
      //update program before session update
      this.selected?.type == 'SESSION' && !history_url ? await this.updateProgram(sessionUpdated?.typeId?._id) : '';

      if (history_url) {
        this.updateForm.controls['title']?.setValue(this.selected.title);
      }
      this.updateForm

      sessionUpdated = {
        "title": this.updateForm.value.title,
        "date": this.updateForm.value.date,
        "start_time": this.updateForm.value.start_time,
        "end_time": this.updateForm.value.end_time,
        "typeId": this.selected?.type == 'SESSION' ? sessionUpdated?.typeId?._id : this.sectionTypeIdHolder?._id,
        "type": this.updateForm.value.type ? this.updateForm.value.type : this.selected?.type,
        "_id": sessionUpdated?._id,
        "status": this.selected?.status ? this.selected?.status : '',
        "active": this.updateForm.value.active ? this.updateForm.value.active : this.selected?.active,
        "history": { history: history_url }
      }

      let res = await this.dataService.postData('session/', sessionUpdated, 'PUT', false);
      if (res.error) {

        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      else {
        this.messages = [
          { severity: 'success', summary: this.translate('success'), detail: res.msg },
        ];
        this.openCourse(this.completeCourseObject._id);
      }

    }
  }

  async createSessionAndCourse(type: any) {
    this.createSurveyFromCourse = false;
    this.newSurvey = false;
    this.sectionTypeIdHolder = '';
    this.unselect = false;
    this.input_vid_url = '';
    this.type = type
    if (type == 'SESSION') {
      this.vidUploaded = false;
      this.createSession = true;
      this.survey = false;
      this.assessment = false;
      this.courseMaterial = false;
      await this.getCity();
    }
    else if (type == 'ASSESSMENT') {
      this.vidUploaded = false;
      this.assessment = true;
      this.survey = false;
      this.createSession = false;
      this.courseMaterial = false;
      await this.getAssessments();
    }

    else if (type == 'SURVEY') {
      this.vidUploaded = false;
      this.survey = true;
      this.assessment = false;
      this.createSession = false;
      this.courseMaterial = false;
      await this.getSurveys();
    }
    //course
    else {
      this.assessment = false;
      this.courseMaterial = true;
      this.survey = false;
      this.createSession = false;
      this.fileUploaded = [];

    }
    this.constructForObject(type);
    this.openProgramModal = true;
  }

  async addProgram() {

    let program: any

    if (this.sessionType == 'onsite') {
      program = {
        "trainer": this.createProgramForm.value.trainer,
        "is_online": this.createProgramForm.value.is_online,
        "address": { houseNumber: this.createProgramForm.value.houseNumber, city: this.createProgramForm.value.city, street: this.createProgramForm.value.street }
      }
    }

    if (this.sessionType == 'online') {
      program = {
        "trainer": this.createProgramForm.value.trainer,
        "is_online": this.createProgramForm.value.is_online,
        "zoom_url": this.createProgramForm.value.zoom_url,

      }
    }

    if (this.sessionType == 'isvideo') {
      program = {
        "trainer": this.createProgramForm.value.trainer,
        "is_online": this.createProgramForm.value.is_online,
        "video_url": this.createProgramForm.value.video_url,
        "seen": false,
      }
    }

    let response: any = await this.dataService.postData('program/', program);
    if (response.error == true) {
      this.message = response.msg;
    }
    else {
      this.message = response.msg;
      await this.addSession('SESSION', response?.data?._id);
    }
  }

  async addSession(type: string, programId: any) {
    try {


      let { title, date, start_time, end_time } = this.createProgramForm.value;

      date.setHours(0, 0, 0, 0)
      date.setMinutes(date.getMinutes() - date.getTimezoneOffset());

      let sessionPay = {
        title: title,
        type: type,
        typeId: programId,

        date: this.number_of_sessions == 1 || this.permissions?.type?.number_of_sessions == 1 ? this.completeCourseObject?.start_date : date,

        start_time: start_time,
        end_time: end_time,
        status: "",
        active: true
      }

      this.newAddedSession = sessionPay;
      let response: any = await this.dataService.postData('session/', sessionPay);
      if (response.error == true) this.message = response.msg;

      else {
        this.message = response.msg;
        let sessionIds: any = [];
        this.completeCourseObject.session.forEach((item: any) => {
          sessionIds.push(item._id);

        });

        sessionIds.push(response?.data?._id);
        await this.updateCourse(type, sessionIds)
        this.resetSession();
      }
    } catch (error) {
      console.log(error)

    }
  }

  // updating course after update session,survey,assessment and course.
  async updateCourse(type: string, sessionCourseIds?: any) {
    try {
      this.confirmationService.close();
      let payload: any;
      let start = new Date(this.completeCourseObject?.start_date);
      start.setHours(0, 0, 0, 0)


      start.setMinutes(start.getMinutes() - start.getTimezoneOffset());

      let end = new Date(this.completeCourseObject?.end_date);
      end.setHours(0, 0, 0, 0)
      // Set the time zone offset to zero
      end.setMinutes(end.getMinutes() - end.getTimezoneOffset());


      if (type == 'SESSION' || type == 'ASSESSMENT' || type == 'SURVEY') {
        payload = {
          "_id": this.completeCourseObject._id,
          "title": this.completeCourseObject.title,
          "description": this.completeCourseObject.description,
          // "type": type,
          "image": this.completeCourseObject.image,
          "start_date": start,
          "end_date": end,
          "session": sessionCourseIds,
          "active": this.completeCourseObject.active,
          "courseMaterial": this.completeCourseObject.courseMaterial
        }
      }
      // courseMaterial
      else {

        payload = {
          "_id": this.completeCourseObject._id,
          "title": this.completeCourseObject.title,
          "description": this.completeCourseObject.description,
          // "type": type ? type : this.completeCourseObject.type,
          "image": this.completeCourseObject.image,
          "start_date": start,
          "end_date": end,
          "session": this.completeCourseObject.session,
          "active": this.completeCourseObject.active,
          "courseMaterial": this.completeCourseObject.courseMaterial,
        }

      }
      payload

      let response: any = await this.dataService.postData('course/', payload, 'PUT', false);
      if (response.error == true) this.message = response.msg;

      else {
        this.message = response.msg;
        // this.completeCourseObject.active ? this.getTrainingRequests() : this.openCourse(this.completeCourseObject._id);
        this.openCourse(this.completeCourseObject._id);
        this.sectionTypeIdHolder = null;
        this.unselect = false;
      }
    } catch (error) {
      console.log(error)
    }
  }

  // handle Session Submission
  async addData(type: string) {
    try {

      let payload;
      if (type == 'SESSION') this.addProgram();

      else if (type == 'SURVEY' || type == 'ASSESSMENT') {
        //check survey / assessment selected or not
        if (this.sectionTypeIdHolder?._id) this.addSession(type, this.sectionTypeIdHolder?._id);

        else {
          this.unselect = true;
          return;
        }

      }
      //course
      else {
        payload = {
          "_id": this.completeCourseObject._id,
          "title": this.completeCourseObject.title,
          "description": this.completeCourseObject.description,
          "type": this.completeCourseObject.type ? this.completeCourseObject.type : 'COURSE',
          "image": this.completeCourseObject.image,
          "start_date": this.completeCourseObject.start_date,
          "end_date": this.completeCourseObject.end_date,
          "session": this.completeCourseObject.session,
          "active": this.completeCourseObject.active,
          "courseMaterial": this.completeCourseObject.courseMaterial
        }
        this.updateCourse(type);
      }

    } catch (error) {
      console.log(error);
      this.unselect = false;
    }
    this.openProgramModal = false;
    this.createSession = false;
    this.assessment = false;
    this.survey = false;
    this.fileUpload = false;
  }


  async getCity() {
    try {
      let res = await this.dataService.getData('location');
      if (!res.error) {
        this.city = res.data.map((location: any) => {
          return {
            value: location.name,
            label: location.name,
            icon: 'pi pi-map-marker',
          };
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  private async getAssessments(): Promise<void> {
    let res = await this.dataService.getData('assessment/1/1000/TAG_10');
    console.log(res.data);
    if (res.error) {
      return;
    }
    this.assessments = res?.data?.data?.map((item: any) => {
      return {
        _id: item._id,
        assessmentTitle: item.name,
        assessmentType: item.type,
        description: item.description,
      };
    });
  }

  //creating form and set required validation base on type..
  constructForObject(type: string) {

    if (type == 'SESSION') {
      let start_date = new Date(this.completeCourseObject?.start_date);
      // start_date.setDate(start_date.getDate() - 1);
      this.createProgramForm = this.formBuilder.group({
        title: [null, [Validators.required, Validators.minLength(3)]],

        date: [this.number_of_sessions == 1 || this.permissions?.type?.number_of_sessions == 1 ? new Date(start_date.toUTCString()) : null, Validators.required],

        start_time: [null, Validators.required],
        end_time: [null, Validators.required],
        trainer: [null, [Validators.required, Validators.minLength(3)]],
        is_online: [null, []],
        is_video: [null, []],
        video_url: [null, []],
        zoom_url: [null, []],
        houseNumber: [null, []],
        street: [null, []],
        city: [null, []],
      });
    }
    else if (!type || type == 'COURSE') {
      this.createProgramForm = this.formBuilder.group({
        url: [null, [Validators.required, Validators.minLength(3)]]
      });
    }
    //SURVEY/Assessment
    else {
      let start_date = new Date(this.completeCourseObject?.start_date);
      // start_date.setDate(start_date.getDate() - 1);
      this.createProgramForm = this.formBuilder.group({
        title: [null, [Validators.required, Validators.minLength(3)]],

        date: [this.number_of_sessions == 1 || this.permissions?.type?.number_of_sessions == 1 ? new Date(start_date.toUTCString()) : null, Validators.required],

        start_time: [null, Validators.required],
        end_time: [null, Validators.required],
      });
    }


    if (type == 'SURVEY') {
      this.newSurvey = true;
      this.createProgramForm.controls['end_time'].clearValidators();
      this.createProgramForm.controls['end_time'].updateValueAndValidity();
      this.createProgramForm.controls['start_time'].clearValidators();
      this.createProgramForm.controls['start_time'].updateValueAndValidity();
      this.createProgramForm.controls['date'].clearValidators();
      this.createProgramForm.controls['date'].updateValueAndValidity();

      this.createProgramForm.controls['title'].clearValidators();
      this.createProgramForm.controls['title'].updateValueAndValidity();
    }

    if (type == 'SURVEY') {
      this.newSurvey = true;
      this.createProgramForm.controls['end_time'].clearValidators();
      this.createProgramForm.controls['end_time'].updateValueAndValidity();
      this.createProgramForm.controls['start_time'].clearValidators();
      this.createProgramForm.controls['start_time'].updateValueAndValidity();
      this.createProgramForm.controls['date'].clearValidators();
      this.createProgramForm.controls['date'].updateValueAndValidity();

      this.createProgramForm.controls['title'].clearValidators();
      this.createProgramForm.controls['title'].updateValueAndValidity();
    }

  }

    removeTimeValidation(){
      if(this.sessionType == 'isvideo'){
        this.createProgramForm.controls['end_time'].clearValidators();
        this.createProgramForm.controls['end_time'].updateValueAndValidity();
        this.createProgramForm.controls['start_time'].clearValidators();
        this.createProgramForm.controls['start_time'].updateValueAndValidity();
      } else {
        this.createProgramForm.controls['end_time'].Validators(Validators.required); 
        this.createProgramForm.controls['end_time'].updateValueAndValidity();
        this.createProgramForm.controls['start_time'].Validators(Validators.required); 
        this.createProgramForm.controls['start_time'].updateValueAndValidity();
      }
    }

  // get Surveys
  private async getSurveys(): Promise<void> {
    let res = await this.dataService.getData('survey/TAG_1');
    console.log(res.data);
    if (res.error) {
      return;
    }
    this.surveys = res.data.map((item: any) => {

      return {
        _id: item._id,
        surveyTitle: item.name,
        description: item.comments,
      };
    });
  }

  // course Update work
  async courseUpdateForms() {
    this.courseFormEdit = !this.courseFormEdit;
    let sessionIds: any = [];
    this.completeCourseObject.session.forEach((item: any) => {
      sessionIds.push(item._id);

    });

    if (this.courseUpdateForm.valid) {
      this.completeCourseObject.title = this.courseUpdateForm.value.title
      this.completeCourseObject.description = this.courseUpdateForm.value.description
      this.completeCourseObject.start_date = this.courseUpdateForm.value.start_date
      this.completeCourseObject.end_date = this.courseUpdateForm.value.end_date
      this.updateCourse(this.completeCourseObject?.type, sessionIds)
    }
    this.updateCurseDate = false;
    this.updateError = '';
  }
  //Edit Course 
  async editCourseForm() {
    this.courseFormEdit = !this.courseFormEdit;
    this.courseUpdateForm = this.formBuilder.group({
      title: ['', Validators.required],
      description: ['', Validators.required],
      start_date: ['', Validators.required],
      end_date: ['', Validators.required],
    });

    let startDate = new Date(this.completeCourseObject.start_date);
    let endDate = new Date(this.completeCourseObject.end_date);
    this.completeCourseObject.start_date = startDate;
    this.completeCourseObject.end_date = endDate;

    this.courseUpdateForm.patchValue(this.completeCourseObject);

  }

  // handle Session Submission
  async onSubmitProgram(type: string) {
    try {
      let typeForm;
      if (type == 'SESSION') typeForm = this.createProgramForm.value;
      //survey or Assessment
      else typeForm = this.sectionTypeIdHolder;

      let { title, date, start_time, end_time } = this.createProgramForm.value
      let typeData: any = {
        title: title,
        type: type,
        typeId: { ...typeForm },
        date: date.toUTCString(),
        start_time: start_time,
        end_time: end_time
      }
      this.completeCourseObject.session.push(typeData)

      let response: any = await this.dataService.postData('course/', this.completeCourseObject);
      if (response.error == true) this.message = response.msg;

      else {
        this.message = response.msg;
        this.resetSession();
        this.openCourse(this.courseDetails._id);
      }
    } catch (error) {
      console.log(error)

    }

    this.openProgramModal = false;
    this.createSession = false;
    this.assessment = false;
    this.survey = false;
  }

  addVideo(event: any) {
    this.vidUploaded = false;
    const file: File = event?.target.files[0];
    let obj: any = {};
    obj['file'] = {
      file: file,
      type: 'data'
    };
    this.handleFileUpload(obj, '', 'video');
  }


  updateVideo(event: any) {
    this.vidUploaded = false;
    const file: File = event?.files[0];
    let obj: any = {};
    obj['file'] = {
      file: file,
      type: 'data'
    };
    this.handleFileUpload(obj, '', 'update_video');
  }

  async addFiles(event: any, name: string) {
    this.fileUpload = false;
    const file: File = event.target.files[0];
    let obj: any = {};
    obj['file'] = {
      file: file,
      type: 'data'
    };
    console.log(obj);
    this.handleFileUpload(obj, name, 'file');
  }

  async updateFiles(event: any, fileName: string, history?: string) {

    const file: File = event?.target.files[0];
    let obj: any = {};
    obj['file'] = {
      file: file,
      type: 'data'
    };

    this.handleFileUpload(obj, fileName, history ? history : 'update_file');
  }

  async courseImage(event: any, type: string) {
    const file: File = event?.target.files[0];
    let obj: any = {};
    obj['file'] = {
      file: file,
      type: 'data'
    };
    this.handleFileUpload(obj, '', type);
  }

  showPdf() {
    this.showPDF = true;
    return this.domSenitizer.bypassSecurityTrustResourceUrl(GlobalConstants.staticFilesURL + this.selected?.url)
  }


  async openCourse(id: any) {
    try {
      let res = await this.dataService.getData('course/get/' + id);
      if (res.error) return;

      let course = res.data[0];
      this.courseDetail(course, false);
      console.log("==>COurse get", res);
    } catch (error) {
      console.log(error);
    }


  }

  handleFileUpload(file: any, fileName: string, eventType: string): string | null {
    this.fileProgress = true;
    this.imageUploadService.uploadImageWithProgress(file.file.file, file.file.type).subscribe({
      next: (event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            this.uploadProgress = Math.round(event.loaded / event.total! * 100);
            console.log(`Uploaded! ${this.uploadProgress}%`);
            break;
          case HttpEventType.Response:
            if (event.ok) {
              setTimeout(() => {
                this.uploadProgress = 0;
              }, 1500);
              switch (eventType) {
                case 'video':
                  this.createProgramForm.controls['video_url']?.setValue(event.body.data);
                  this.vidUploaded = true;
                  break;
                case 'update_video':
                  this.updateVid = true;
                  this.selected.typeId.video_url = event.body.data;
                  this.updateForm.controls['video_url']?.setValue(event.body.data);
                  this.vidUploaded = true;
                  break;

                case 'file':
                  this.completeCourseObject.courseMaterial.push({
                    url: event.body.data,
                    title: fileName,
                    order: this.completeCourseObject.courseMaterial?.length + 1
                  });
                  this.fileUploaded.push({ url: event.body.data, title: fileName });
                  this.fileUpload = true;
                  break;

                case 'update_file':
                  const indexToReplace = this.completeCourseObject.courseMaterial.findIndex((courseMaterial: any) => courseMaterial.title === fileName);
                  if (indexToReplace >= 0) {
                    this.completeCourseObject.courseMaterial[indexToReplace] = {
                      url: event.body.data,
                      title: fileName
                    };
                  }
                  this.updateForm.controls['title'].setValue(fileName);
                  this.updateCourseData.push({ url: event.body.data, title: fileName });

                  break;

                case 'history':
                  this.history_url = '';
                  this.history_url_id = '';
                  this.history_url = event.body.data;

                  break;

                case 'course-img-update':
                  this.completeCourseObject.image = event.body.data;
                  break;
              }
            } else {
              this.messages = [
                { severity: 'error', summary: this.translate('error') },
              ]
            }
        }
      },
      error: (error) => {
        this.fileProgress = false;
        this.uploadProgress = 0;
        this.messages = [
          { severity: 'error', summary: this.translate('error') },
        ]
      },
      complete: () => {
        this.fileProgress = false;
        this.uploadProgress = 0;
        this.messages = [
          { severity: 'success', summary: this.translate('success') },
        ]
      }
    })
    return ""
  }

  shiftItem(indexToRemove: number, type: string): void {
    let newIndex = type ? indexToRemove - 1 : indexToRemove + 1;

    this.materialOrderChanged = true;

    this.selectedTab.splice(newIndex, 0, ...this.selectedTab.splice(indexToRemove, 1));
    this.updateCourse('materialOrderChanged');
  }

  nameChange() {
    if (this.fileUpload) this.completeCourseObject.courseMaterial[this.completeCourseObject.courseMaterial?.length - 1].title = this.createProgramForm.get('url').value;

  }

  resetSession() {
    this.sectionTypeIdHolder = null;
    this.createProgramForm.reset();
  }

  goBack() {
    window.location.reload();
  }

  onlineChange() {
    if (!this.createProgramForm.value.is_online) this.createProgramForm.controls['is_video'].setValue(false);
  }

  // delete session / course material
  actionCall(id: string) {
    if (this.selected.type == 'SESSION' || this.selected.type == 'SURVEY' || this.selected.type == 'ASSESSMENT') this.deleteSession(id)
    // delete course material
    else {
      this.courseMaterials = this.courseMaterials.filter((item: any) => item.title + item.url !== id);
      this.completeCourseObject.courseMaterial = this.courseMaterials;
      this.updateCourse('');
    }

  }


  deleteSessionCourseMaterial(id: string) {
    if (id == this.selectedItem) {
      this.confirm({
        message: this.translate('Are you sure you want to delete?'),
        header: this.translate('Confirmation message'),
        icon: 'pi pi-exclamation-triangle',
        action: () => this.actionCall(id),
      });
    }
  }


  deleteSession = async (id: string) => {
    try {
      let res = await this.dataService.deleteData(`session/${id}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.confirmationService.close();
      this.openCourse(this.completeCourseObject._id);
    } catch (error) {
      console.log(error);
    }
  };

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });

  }




  async addAttendees(event: any) {

    if (event.emit) {
      let course = { _id: this.courseDetails._id, attendees: [] }
      course.attendees = event.users.map((u: any) => u._id);
      this.courseDetails.attendees = course.attendees;
      this.courseDetails = course;
      this.saveAttendees();
    }
    if (this.courseDetails?.fromCreateCourse && !event.emit) {
      let res = await this.dataService.postData('user/get', { 'ou': this.permissions?.ou?._id })

      this.courseDetails.attendees = res?.data.map((u: any) => u._id)
      if (this.courseDetails?.fromSkills) delete this.courseDetails.fromSkills;

      delete this.courseDetails.fromCreateCourse;
      this.saveAttendees();
    }
    this.addUser = false;
  }

  async saveAttendees() {
    try {
      let response: any = await this.dataService.postData('course/', this.courseDetails, 'PUT', false);
      if (!response.error) {
        this.messages = [
          { severity: 'success', summary: this.translate('success') },
        ];
      }
    } catch (e) {
      console.log(e);
    }
  }

  openTrainingDetailsModal(sessionAtt: any, historyView: boolean) {
    this.trainingModal = true;
    sessionAtt.courseAttendees = this.completeCourseObject?.attendees;
    this.sessionAtt = sessionAtt;

    historyView ? this.sessionAtt.historyView = { view: true, proof: sessionAtt.attendanceProof?.proof_url } :
      this.sessionAtt.historyView = { view: false, proof: sessionAtt.attendanceProof?.proof_url };

  }

  updatedAttendees(data: any) {
    this.trainingModal = false;
    this.openCourse(this.courseDetails._id);

  }

  createFormDateCheck(SelectedDate: any) {
    let today = new Date();
    let startDate = new Date(this.completeCourseObject.start_date);
    let endDate = new Date(this.completeCourseObject.end_date);

    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - today.getDay()); // Start of the current week

    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6); // End of the current week

    if (!(startDate.setHours(0, 0, 0, 0) <= SelectedDate.setHours(0, 0, 0, 0) && endDate.setHours(0, 0, 0, 0) >= SelectedDate.setHours(0, 0, 0, 0))) {
      this.createProgramForm.controls['date'].setValue(null);
      this.invalidDate = "Please select a date within the course";

    }

    else if (SelectedDate < today) {
      this.invalidDate = "invalid Date select greater than today";
      this.createProgramForm.controls['timeline']?.setValue(null);
    }

    else if (this.data?.type?.name == "WEEKLY" && !(SelectedDate >= startOfWeek && SelectedDate <= endOfWeek)) {
      this.invalidDate = "invalid Date select in current week";
      this.createProgramForm.controls['timeline']?.setValue(null);

    }

    else if (this.data?.type?.name == "Unified session" && SelectedDate.getMonth() + 1 != this.data?.date?.id) {
      this.invalidDate = "invalid Date select in current Month : " + this.data?.date?.id;
      this.createProgramForm.controls['timeline']?.setValue(null);
    }

    else this.invalidDate = "";
  }


  convertToDate(data: any): Date {
    return new Date(data)
  }


  updateFormDateCheck(SelectedDate: any) {
    let startDate = new Date(this.completeCourseObject.start_date);
    let endDate = new Date(this.completeCourseObject.end_date);

    if (!(startDate <= SelectedDate && endDate >= SelectedDate)) {
      this.updateForm.controls['date'].setValue(null);
      this.checkDate = true;
    }
    else this.checkDate = false;

  }

  startTimeChange() {
    this.startTime = this.timeToMinutes(this.createProgramForm.get('start_time').value);
    if (!(this.startTime < this.endTime)) {
      this.createProgramForm.controls['end_time'].setValue(null);
      this.endTimeInvalid = true;
    }
    else this.endTimeInvalid = false;
  }

  endTimeChange() {
    this.endTime = this.timeToMinutes(this.createProgramForm.get('end_time').value);
    if (!(this.startTime < this.endTime)) {
      this.createProgramForm.controls['end_time'].setValue(null);
      this.endTimeInvalid = true;
    }
    else this.endTimeInvalid = false;
  }


  dateCheck(SelectedDate: any, type: string) {

    this.courseUpdateForm

    let today = new Date();

    let startDate = new Date(this.courseUpdateForm.value.start_date);
    let endDate = new Date(this.courseUpdateForm.value.end_date);
    const selectedDay = startDate.getDay();

    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - (today.getDay() + 2) % 7);


    // Set the end of the week to the next Thursday
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);

    if (!(startDate.setHours(0, 0, 0, 0) <= endDate.setHours(0, 0, 0, 0))) {
      if (type == 'end') {
        this.updateCurseDate = type;
        this.courseUpdateForm.controls['end_date'].setValue(null);
        this.updateError = 'End date should be greater'

      }
      else {
        this.updateCurseDate = type;
        this.courseUpdateForm.controls['start_date'].setValue(null);
        this.updateError = 'Start date should be less'

      }
    }

    else if (selectedDay === 5 || selectedDay === 6) { // 5 is Friday, 6 is Saturday

      this.updateCurseDate = type;
      this.updateError = "Please select a date other than Friday or Saturday";
      this.courseUpdateForm.controls['start_date'].setValue(null);
      return;
    }

    // else if (this.reqType =='Unified session') {
    //   
    //     if (SelectedDate.getFullYear() != this.data?.date?.year || SelectedDate.getMonth() + 1 != this.data?.date?.id) {
    //       this.updateCurseDate = type;
    //       this.updateError = "invalid Date select in current Month : " + this.data?.date?.id;
    //       this.courseUpdateForm.controls['start_date'].setValue(null);
    //     }
    //   }

    // session 1 h to end date start date same hogi
    else if (this.permissions?.type?.number_of_sessions == 1 && this.courseUpdateForm.controls['start_date'].value) {

      this.courseUpdateForm.controls['end_date'].setValue(this.courseUpdateForm.controls['start_date'].value);
      this.updateError = '';
    }

    // "reqType == 'WEEKLY' && reqType !='Unified session'
    else if (this.reqType == 'WEEKLY' && !(startDate >= startOfWeek && startDate <= endOfWeek)) {

      this.updateCurseDate = type;
      this.updateError = "invalid Date select in current week";
      this.courseUpdateForm.controls['start_date'].setValue(null);

    }

    else this.updateCurseDate = false;

  }

  startTimeChangeUpdate() {
    this.startTimeUp = this.timeToMinutes(this.updateForm.get('start_time').value);
    if (!(this.startTimeUp < this.endTimeUp)) {
      this.updateForm.controls['end_time'].setValue(null);
      this.endTimeInvalidUpd = true;
    }
    else this.endTimeInvalidUpd = false;
  }

  endTimeChangeUpdate() {
    this.endTimeUp = this.timeToMinutes(this.updateForm.get('end_time').value);
    if (!(this.startTimeUp < this.endTimeUp)) {
      this.updateForm.controls['end_time'].setValue(null);
      this.endTimeInvalidUpd = true;
    }
    else this.endTimeInvalidUpd = false;
  }



  timeToMinutes(time: string) {
    if (time) {
      const [hours, minutes] = time.split(':').map(Number);

      return hours * 60 + minutes;
    }
    return 0;
  }

  createSurvey() {
    this.createSurveyFromCourse = true;
    this.createProgramForm

    this.createProgramForm.controls['end_time'].clearValidators();
    this.createProgramForm.controls['end_time'].updateValueAndValidity();
    this.createProgramForm.controls['title'].clearValidators();
    this.createProgramForm.controls['title'].updateValueAndValidity();
    this.createProgramForm.controls['start_time'].clearValidators();
    this.createProgramForm.controls['start_time'].updateValueAndValidity();
    this.createProgramForm.controls['date'].clearValidators();
    this.createProgramForm.controls['date'].updateValueAndValidity();


  }
  updateSurvey(data: any) {
    this.updateSurveyData = data;
  }

  updateAsses(data: any) {
    this.updateAssesData = data;
  }

  addedNewSurvey(newSurvey: any) {
    const [day, month, year] = newSurvey?.data?.startDate.split('-').map(Number);
    this.createProgramForm.controls['date']?.setValue(new Date(year, month - 1, day));
    this.createProgramForm.controls['title']?.setValue(newSurvey?.data?.name);
    this.createSurveyFromCourse = false;
    this.sectionTypeIdHolder = newSurvey?.data;
    this.addData('SURVEY');
  }

  addedAssess(newAssess: any) {
    this.createSurveyFromCourse = false;
    this.assessments.push({
      _id: newAssess?.data?._id,
      description: newAssess?.data?.comments,
      assessmentType: "Assess",
      assessmentTitle: newAssess?.data?.name
    })
    this.sectionTypeIdHolder = newAssess?.data;
  }

  async updateSurveys(updated: any) {
    this.updateSurveyData = null;
    this.createSurveyFromCourse = false;
    let currentSession = this.completeCourseObject.session.find((e: any) => e._id === this.selected?._id);

    let sessionUpdated = {
      "typeId": this.selected?.typeId._id,
      "_id": currentSession._id
    }

    let response = await this.dataService.postData('session/', sessionUpdated, 'PUT', false);
    if (response.error == true) this.message = response.msg;

    else {
      this.message = response.msg;
      this.openCourse(this.completeCourseObject._id);
      this.sectionTypeIdHolder = null;
      this.unselect = false;
    }

  }

  async updateAssesment(updated: any) {
    this.updateAssesData = null;
    this.createSurveyFromCourse = false;

    let currentSession = this.completeCourseObject.session.find((e: any) => e._id === this.selected?._id);

    let sessionUpdated = {
      "typeId": this.selected?.typeId._id,
      "_id": currentSession._id
    }

    let response = await this.dataService.postData('session/', sessionUpdated, 'PUT', false);
    if (response.error == true) this.message = response.msg;

    else {
      this.message = response.msg;
      this.openCourse(this.completeCourseObject._id);
      this.sectionTypeIdHolder = null;
      this.unselect = false;
    }

  }


  handleUpdatedUserData(data: any) {
    this.addTrainnerModal = false;
    this.trainersAdded = true;
    this.getTrainers(this.internalExternalValue);
  }

  stripHtmlTags(html: string): string {
    if (!html) return '';
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }
}
